const NotFoundPage = () => {
  return (
    <div className="flex min-h-screen items-center justify-center">
      <h1 className="text-red-500 text-3xl font-bold">PAGE NOT FOUND</h1>
    </div>
  );
};

export default NotFoundPage;
